// src/app/core/firebase/firebase.client.ts
import { initializeApp, getApps, getApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getFirestore, Firestore } from 'firebase/firestore';
import { FIREBASE_CONFIG } from './firebase.config';

function getOrCreateApp(): FirebaseApp {
    if (getApps().length > 0) {
        return getApp();
    }
    return initializeApp(FIREBASE_CONFIG);
}

export const firebaseApp: FirebaseApp = getOrCreateApp();

export const firebaseAuth: Auth = getAuth(firebaseApp);

export const firebaseDb: Firestore = getFirestore(firebaseApp);

